__turbopack_context__.v({
  "EmbeddedVideo": "vK7fKG_EmbeddedVideo",
});
